import { useState, useEffect, useRef } from 'react';
import SideDrawer from './components/side-drawer';
import Styles from './leasing-modal.module.scss';
import { TYPES } from '../constants';
import { financingOfferLogos } from './constants';
import { IPaymentState } from '~/interfaces/payment';

interface LeasingModalProps {
  syfTabBody?: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  defaultOpeningTab?: number;
  progressiveTotalAmount?: number;
  balanceAmount?: number;
  paymentState?: IPaymentState;
}

const LeasingModal: React.FC<LeasingModalProps> = ({
  syfTabBody,
  isOpen,
  setIsOpen,
  defaultOpeningTab,
  progressiveTotalAmount,
  balanceAmount,
  paymentState,
}) => {
  const lowerCaseTypes = {
    synchrony: TYPES.SYNCHRONY.toLowerCase(),
    affirm: TYPES.AFFIRM.toLowerCase(),
    progresive: TYPES.PROGRESIVE.toLowerCase(),
  };
  const filteredOffers = financingOfferLogos.filter(
    (offer) =>
      paymentState &&
      !(
        offer.name === lowerCaseTypes.synchrony &&
        paymentState.isStoreBlockingSynchrony
      ) &&
      !(
        offer.name === lowerCaseTypes.affirm &&
        paymentState.isStoreBlockingAffirm
      ) &&
      !(
        offer.name === lowerCaseTypes.progresive &&
        paymentState.isStoreBlockingProgressive
      ),
  );

  const defaultTab = filteredOffers[0]?.index ?? -1;
  const initialTab =
    defaultOpeningTab !== undefined ? defaultOpeningTab : defaultTab;
  const [activeTab, setActiveTab] = useState(initialTab);

  const prevIsOpen = useRef(isOpen);

  useEffect(() => {
    if (!prevIsOpen.current && isOpen) {
      setActiveTab(
        defaultOpeningTab !== undefined ? defaultOpeningTab : defaultTab,
      );
    }
    prevIsOpen.current = isOpen;
  }, [isOpen, defaultOpeningTab, defaultTab]);

  return (
    <div className={Styles.offerSection}>
      <SideDrawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        filteredOffers={filteredOffers}
        lowerCaseTypes={lowerCaseTypes}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        syfTabBody={syfTabBody}
        progressiveTotalAmount={progressiveTotalAmount}
        balanceAmount={balanceAmount}
      />
    </div>
  );
};

export default LeasingModal;
